export default __webpack_public_path__ + "static/media/pheasants-forever.b2228564.png";